import { usePickZones } from "@/hooks/pick-zones";

import { PickZonesTemplate } from "./pick-zones.template";

export const PickZones = () => {
	const { data, isLoading, isFetchedAfterMount, error, refetch } = usePickZones();

	return (
		<PickZonesTemplate
			pickZones={data}
			isLoading={isLoading || isFetchedAfterMount === false}
			isError={Boolean(error)}
			onRetry={refetch}
		/>
	);
};
